export const home = {
  loadingLandingPage: 'Please wait. Loading Landing page Data...',
  welcome: (name: string) => `Welcome, ${name}!`,
  lastLogin: (date: string) => `Last login: ${date}`,
  v1: {
    cards: {
      medicationTherapyManagement: 'Medication Therapy Management',
      transitionalCareManagement: 'Transitional Care Management',
      patients: 'Patients',
      remotePatientMonitoring: 'Remote Patient Monitoring'
    },
    summary: {
      tasksAssignedToMe: 'Tasks assigned to me',
      tasksDueToday: 'Tasks due today',
      tcmTasksAssignedToMe: 'TCM Tasks assigned to me',
      tcmTasksDueToday: 'TCM Tasks due today',
      patientsAssignedToMe: 'Patients assigned to me',
      patientsToFollowUpToday: 'Patients to follow up today',
      enrolledPatients: 'Enrolled Patients',
      connectedDevices: 'Connected Devices'
    },
    actions: {
      myTasks: 'My Tasks',
      myTcmTasks: 'My TCM Tasks',
      patientsLookup: 'Patients Lookup',
      patients: 'Patients'
    }
  },
  v2: {
    sections: {
      general: 'General',
      upcomingFollowUps: 'Upcoming Follow ups',
      healthcareManagement: 'Healthcare Management',
      remotePatientMonitoring: 'Remote Patient Monitoring',
      recentNews: 'Recent News'
    },
    kpi: {
      numberOfPatients: 'Number of Patients',
      patientsToFollowUp: 'Patients to Follow Up',
      enrolledPatients: 'Enrolled Patients',
      connectedDevices: 'Connected Devices'
    },
    deviceBreakdownChartTitle: 'Device Breakdown',
    healthcareManagementVideoTitle: 'YouTube video player'
  }
} as const;
